export default {"src":"/_next/static/media/locator-big-green.5d421b02.svg","height":35,"width":26};